export const GUIDED_VIEWS = ["home", "projects", "new", "scan", "scan-opportunities", "project", "more"] as const;

export type GuidedView = (typeof GUIDED_VIEWS)[number];

export function isGuidedView(value: string): value is GuidedView {
  return (GUIDED_VIEWS as readonly string[]).includes(value);
}

export const GUIDED_DOCK_VIEWS = ["home", "projects", "more"] as const;

export type GuidedDockView = (typeof GUIDED_DOCK_VIEWS)[number];

export const GUIDED_VIEW_META: Record<GuidedView, { readonly title: string; readonly subtitle: string }> = {
  home: {
    title: "Command Center",
    subtitle: "Portfolio intelligence, running work, and one next action per project.",
  },
  projects: {
    title: "Projects",
    subtitle: "Every client in one list — open a project to continue.",
  },
  new: {
    title: "New project",
    subtitle: "Start with a name, contact, project type, and how you want to begin.",
  },
  scan: {
    title: "Scan existing site",
    subtitle: "Find fix opportunities and turn them into client work.",
  },
  "scan-opportunities": {
    title: "Scan opportunities",
    subtitle: "Claimed reports, Fix Kit, and relaunch preview.",
  },
  project: {
    title: "Project room",
    subtitle: "One current step and one next action for this client.",
  },
  more: {
    title: "More",
    subtitle: "Advanced tools — proof records, lab, and confirmation queue.",
  },
};
